var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5","d":"m17.25 1.25-11 11-5-5"}));
}

Check.defaultProps = {"width":"18.5","height":"13.5","data-name":"Layer 1","viewBox":"0 0 18.5 13.5"};

module.exports = Check;

Check.default = Check;
